import { getUrlFromEnv } from "../../../services/api/config/utils/getUrlFromEnv";
import type { CompareObject } from "../../../services/api/instances/comparisonAPI/types";
import type {
  Model,
  ModelsValue,
} from "../../../services/api/instances/modelsApi/types";

export const sortModelsByServerType = (models: Model[]): Model[] => {
  const groupOrder = ["openai", "deepseek", "Yandex", "onprem-rmd", "qwen"];

  return models.sort((a, b) => {
    const indexA = groupOrder.indexOf(a.server_type);
    const indexB = groupOrder.indexOf(b.server_type);
    return indexA - indexB;
  });
};

export const getSubstringAfterFixedPart = (
  input: string,
  fixedPart: string,
): string => {
  return input.replace(fixedPart, "");
};

export const getModelUrl = (
  models: ModelsValue,
  comparisonObject: CompareObject,
): string => {
  const serverType = models.models.find(
    (model) => model.model_name === comparisonObject.model,
  )?.server_type;
  const chatUrl = models.servers.find(
    (server) => server.server_type === serverType,
  )?.chat_complections_url;
  const baseUrl = getUrlFromEnv("REACT_APP_BASE_URL");
  return getSubstringAfterFixedPart(chatUrl as string, baseUrl);
};

export const getModel = (
  models: Model[],
  value: CompareObject[],
  id: string,
): Model | null => {
  if (!models) {
    return null;
  }
  const currentValue = value.find((item) => item.id === id);
  const model = models.find(
    (item) => item?.model_name === currentValue?.model,
  ) as Model;
  if (model) {
    return model;
  }
  return null;
};
